"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tinyMCE = "d0jtsz0h5cen3a31nqwuwtmyvg0sqmyn0dtfvxxpzvp5gygj";

var config = {
  tinyMCE: tinyMCE
};

exports.default = config;